<div class="col position-relative wccard py-7">
  <p class="f-16 font-weight-600">{{talentpoolName}}</p>

  <div class="d-flex" style="justify-content: space-evenly;">
    <img [src]="imgSrc" class="card-img" />
    <div class="d-flex flex-wrap" style="width: 360px; " >
     
          

      <!-- <div >
        <ngb-carousel >
          <ng-template ngbSlide *ngFor="let i of bucketList; let j = index">
            <div class="d-flex flex-column box-border mr-3 mb-0 item p-2 pointer" 
                (click)="redirectToListing(i.talentpoolbucketname)">
                <p class="font-weight-600 text-webbtree-green mb-1 text-truncate"
                  style="margin-bottom: 11px;padding-bottom: 17px;">{{i.talentpoolbucketname}}</p>
                <span class="text-9696 pointer" style="margin-top: -6px;">{{convertToK(i.count)}} Profiles &gt;</span>
              </div>
              <div class="carousel-caption">
                <h3>Third slide label</h3>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
              </div>
            </ng-template>
        </ngb-carousel>
      </div> -->

      
      <!-- style="background-color: red; display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;" -->
      <ngb-carousel data-interval="false">
        <ng-template ngbSlide *ngFor="let slideItems of chunkedBucketList; let slideIndex = index" >
          
          <div class=" box-border item p-2 pointer"
                *ngFor="let i of slideItems; let itemIndex = index"
                (click)="redirectToListing(i)">
                <div>
            <p class="font-weight-600 text-webbtree-green mb-1 text-truncate" [matTooltip]="i.talentpoolbucketname" [matTooltipClass]="{ 'red-tooltip': true }"  matTooltipPosition="right">
              {{ i.talentpoolbucketname }}
            </p>
            <span class="text-9696 pointer">
              {{ convertToK(i.count) }} Profiles &gt;
            </span>
          </div>
          </div>
        
        </ng-template>
      </ngb-carousel>

    </div>
  </div>

</div>